import { useEffect, useState } from 'react';
import classnames from 'classnames';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_LINKS } from '@/helpers/links';
import { AccountTypeTabs } from '@/components/AccountTypeTabs';
import { useUserStore } from '@/store/userStore';
import s from './index.module.scss';

const TABS = t => [
  {
    label: t('reports_root.cash_movements'),
    path: APP_LINKS.cashMovements,
  },
  {
    label: t('reports_root.portfolio_movements'),
    path: APP_LINKS.portfolioMovements,
  },
  {
    label: t('reports_root.tax_report'),
    path: APP_LINKS.taxReport,
  },
];

const ActivityPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('activity');
  const { accountType } = useUserStore(state => state);
  const [tab, setTab] = useState(accountType);

  useEffect(() => {
    if (location.pathname === APP_LINKS.activity) {
      navigate(APP_LINKS.cashMovements, { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (!tab && accountType) {
      setTab(accountType);
    }
  }, [accountType, tab]);

  return (
    <div className={s.page}>
      <div className="container-inner">
        <div className={s.top}>
          <div className={s.header}>
            <h1 className="f-hero-h2">{t('reports_root.reports')}</h1>
            <p className="f-paragraph-regular">{t('reports_root.view_analyze')}</p>
          </div>
          <AccountTypeTabs selected={tab} className="withdraw-form__tabs" onChange={setTab} />
        </div>

        <div className={s.navigation}>
          {TABS(t).map(tab => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                classnames(s.link, isActive && s.link_active, 'f-article-regular')
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
        <Outlet context={{ type: tab }} />
      </div>
    </div>
  );
};

export default ActivityPage;
